var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowCarryKing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yellow_carry_king_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.405 12V-1h14.81v13zm2.802-9.4a.5.5 0 00-.774.474l.822 6.984a.5.5 0 00.496.442h8.111a.5.5 0 00.497-.442l.821-6.983a.5.5 0 00-.773-.475L9.497 4 7.404 1.07a.5.5 0 00-.814 0L4.497 4l-2.1-1.4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff07b",
    d: "M2.397 2.6l2.1 1.4L6.59 1.07a.5.5 0 01.814 0L9.497 4l2.1-1.4a.5.5 0 01.773.475l-.821 6.983a.5.5 0 01-.497.442h-8.11a.5.5 0 01-.497-.442l-.822-6.984a.5.5 0 01.774-.474z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#191c40",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M2.397 2.6l2.1 1.4v0L6.59 1.07a.5.5 0 01.814 0L9.497 4v0l2.1-1.4a.5.5 0 01.773.475l-.821 6.983a.5.5 0 01-.497.442h-8.11a.5.5 0 01-.497-.442l-.822-6.984a.5.5 0 01.774-.474z",
    clipPath: "url(\"#a\")"
  })));
}
export default __webpack_public_path__ + "static/svg/yellow_carry_king.svg";
export { SvgYellowCarryKing as ReactComponent };